import React from "react";
import CheckIcon from "@mui/icons-material/Check";
import { getInitials } from "../../utilities/helpers";
import { getCardColor2 } from "../../../../../helpers/helpers";

function TradeTargetCard(props) {
  const shiftCardColor = getCardColor2(props.roleId, props.roleNames, false);

  return (
    <div
      className={`w-full flex items-center rounded-xl px-3 py-3 cursor-pointer transition-colors ${
        props.selected
          ? "bg-violet-50 border border-violet-200"
          : "bg-slate-50 border border-slate-100 hover:border-slate-300"
      }`}
      onClick={props.handleTradePress}
    >
      <div
        className={`w-9 h-9 ${shiftCardColor} rounded-full flex items-center justify-center`}
      >
        <p className="text-white text-xs">{getInitials(props.name)}</p>
      </div>
      <div className="ml-3 flex-1">
        <p className="text-sm font-semibold text-slate-900">{props.name}</p>
        <p className="text-xs text-slate-500 mt-0.5">
          {props.shiftStartNumber}{props.shiftStartLetters?.toLowerCase() || ""} - {props.shiftEndNumber}{props.shiftEndLetters?.toLowerCase() || ""}
          {" "}&middot;{" "}
          {props.station
            ? props.station?.name
            : props.role
            ? props.role
            : props.roleType}
          {props.location && <> &mdash; {props.location}</>}
        </p>
      </div>
      {props.selected ? (
        <div className="w-6 h-6 bg-violet-600 rounded-full flex items-center justify-center">
          <CheckIcon sx={{ fontSize: 14, color: "white" }} />
        </div>
      ) : (
        <div className="w-6 h-6 rounded-full border-2 border-slate-300"></div>
      )}
    </div>
  );
}

export default TradeTargetCard;
